/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import notify from 'devextreme/ui/notify';

export default {
    showSuccessMessage(message: string) {
        this.showNotification(message, 'success');
    },
    showErrorMessage(message: string) {
        this.showNotification(message, 'error');
    },
    showAxiosError(err: any) {
        if (err.response) {
            const responseValue: any = err.response.data ? err.response.data : err.response;
            if (typeof responseValue === 'string') {
                this.showErrorMessage(responseValue);
                return;
            }

            if (typeof responseValue === 'object' && responseValue.errors) {
                try {
                    for (const [key, value] of Object.entries(responseValue.errors)) {
                        const message = (value as string[])[0];
                        this.showErrorMessage(`(${key}) ${message}`);
                        return;
                    }
                } catch {
                    // empty
                }
            }


            if (typeof responseValue === 'object' && err.response instanceof Blob && err.status == 400) {
                this.showErrorMessage("Document genereren is niet mogelijk wegens een subcode die hetzelfde is als de hoofdcode");
                return;
            }
        }
        this.showErrorMessage('Er is iets misgelopen!');
    },
    failedToLoad() {
        this.showErrorMessage('Er is iets misgelopen tijdens het ophalen van de data');
    },
    failedToSave() {
        this.showErrorMessage('Er is iets misgelopen tijdens het opslaan van de data');
    },
    saved() {
        this.showSuccessMessage('opgeslagen!');
    },
    zenmodeEnabled() {
        this.showSuccessMessage('Zenmodus is ingeschakeld!');
    },
    zenmodeDisabled() {
        this.showSuccessMessage('Zenmodus is uitgeschakeld!');
    },
    invalidForm() {
        this.showErrorMessage('Het formulier is niet correct ingevuld!');
    },
    showNotification(message: string, type: 'info' | 'warning' | 'error' | 'success') {
        notify({
            message,
        }, type, 3000);
    },
};
